class ProfileEmailHelperService {
    static updatePrimaryEmail(self) {
        if (self.doURLContainsToken) {
            let url = app.appUtil.getQueryParameters(window.location.href);
            self.validateEmail(encodeURI(url.token), encodeURI(url.oktaId.replace(/#profile/,"")));
        }else {
            self.getProfileData();
        }
    }

    static validatePrimaryEmail(self,tokenData,oktaIdData) {
        let UpdateProfileVO = { urlParams: { oktaID: oktaIdData.replace(/#profile/,""), token: tokenData } };
        app.profileSettingsService.validateEmailTokenV2(UpdateProfileVO).then((validateTokenResponse) => {
            if(app.appService.isAuthenticated()){
                if (validateTokenResponse.status && validateTokenResponse.status.toUpperCase() === 'SUCCESS') {
                    let userInfo = app.appService.getUserInfo();
                    userInfo.email = validateTokenResponse.newEmailId;
                    userInfo.profileData.profile.login = validateTokenResponse.newEmailId;
                    userInfo.profileData.profile.email = validateTokenResponse.newEmailId;
                    userInfo.profileData.profile.eixSCEpendingEmail = '';
                    app.appService.setUserInfo(userInfo);
                    self.shouldComponentRenderFlag = true;
                    self.getProfileData();
                }else if(!_.isEmpty(validateTokenResponse.errorCode)) {
                    if((validateTokenResponse.errorCode === app.appUtil.getAppConstants().USER_VERIFIED) || (validateTokenResponse.errorCode === app.appUtil.getAppConstants().ACTIVATION_INVALID)){
                        self.verficationErrorHandler(true);
                    }
                }
            }else if(!app.appService.isAuthenticated()){
                if (validateTokenResponse.status && validateTokenResponse.status.toUpperCase() === 'SUCCESS') {
                    const tempSessionObj = {
                        emailId: validateTokenResponse.emailId, newEmailId: validateTokenResponse.newEmailId, 
                        token: tokenData, oktaId: oktaIdData
                    };
                    app.appService.setSessionstorage('profileUpdatedEmailData',tempSessionObj);
                    app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.PROFILE_SETTINGS_VERIFICATION);
                }else if(!_.isEmpty(validateTokenResponse.errorCode)) {
                    if((validateTokenResponse.errorCode === app.appUtil.getAppConstants().USER_VERIFIED) || (validateTokenResponse.errorCode === app.appUtil.getAppConstants().ACTIVATION_INVALID)){
                        app.appService.setSessionstorage('profileUpdatedEmailData',validateTokenResponse);
                        app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.PROFILE_SETTINGS_VERIFICATION);
                    }
                }
            }
        }, (reject) => {
        });
    }
}
export default ProfileEmailHelperService;
